import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faHeart, faHandshake, faHandHoldingHeart, faUserFriends, faPeopleCarry, faHandHoldingMedical, faHandHoldingUsd, 
    faHandsHelping, faUserCheck, faMedal, faPrayingHands
} from '@fortawesome/free-solid-svg-icons';
import { AboutZa, AboutFounder } from './../../elements/AboutElements';


const AboutSections = () => (
    <Fragment>
        <AboutZa>
            <div className="container">
                <div className="about-block">
                    <h3>About <span className="effect">Za Power House</span></h3>
                    <p>
                        Za Power House is a award winning non-profit organisation
                        that was foundered by Zanele Phakathi who felt the need to
                        give back to her community. The organisation is aim for
                        mostly young people to stay motivated and give back to their
                        community in any way possible. We promote responsible and
                        hardworking citizens and we understand Ubuntu is one of the
                        best ways to develop a community and bring unity. This
                        organisation is home based and has no structure. All its
                        members are volunteers who want to have a positive impact to
                        other people.
                    </p>
                </div>
                <div className="about-block">
                    <h3>Our <span className="effect">Mission</span></h3>
                    <p>
                        Our mission is to give resident of
                        Soweto an opportunity to get
                        involved in community service on a
                        regular basis. Our mission is to help
                        develop each other as people
                        without expecting anything in return.
                    </p>
                </div>
                <div className="about-block">
                    <h3>Our <span className="effect">Vision</span></h3>
                    <p>
                        We strive in
                        creating a Soweto with responsibility,
                        hardworking and vibrant young people,
                        and while doing that to create a united
                        community that always helps one another.
                    </p>
                </div>
                <div className="about-block">
                    <h3>Our <span className="effect">Values</span></h3>
                    <div className="values">
                        <div className="value">
                            <FontAwesomeIcon icon={faHandshake} />
                            <p>Mutual respect</p>
                        </div>
                        <div className="value">
                            <FontAwesomeIcon icon={faHandHoldingHeart} />
                            <p>Honesty</p>                        
                        </div>
                        <div className="value">
                            <FontAwesomeIcon icon={faUserFriends} />
                            <p>Friendship</p>    
                        </div>
                        <div className="value">
                            <FontAwesomeIcon icon={faPeopleCarry} />
                            <p>Teamwork</p>  
                        </div>
                        <div className="value">
                            <FontAwesomeIcon icon={faHandHoldingMedical} />
                            <p>Responsibility</p> 
                        </div>
                        <div className="value">
                            <FontAwesomeIcon icon={faHandHoldingUsd} />
                            <p>Accountability</p>   
                        </div>
                        <div className="value">
                            <FontAwesomeIcon icon={faHandsHelping} />
                            <p>Commitment</p>  
                        </div>
                        <div className="value">
                            <FontAwesomeIcon icon={faUserCheck} />
                            <p>Discipline</p> 
                        </div>
                        <div className="value">
                            <FontAwesomeIcon icon={faMedal} />
                            <p>Success</p>
                        </div>
                        <div className="value">
                            <FontAwesomeIcon icon={faHeart} />
                            <p>Love for community</p>                   
                        </div>
                        <div className="value">
                            <FontAwesomeIcon icon={faPrayingHands} />
                            <p>Sympathy</p>  
                        </div>
                    </div>
                </div>
            </div>
        </AboutZa>
        <AboutFounder>
            <div className="container">
                <div className="two-sections">
                    <div className="left-content">
                        <h2>The Founder - <span className="effect">Zanele Phakathi</span></h2>
                        <p>
                            Nontobeko Zanele Phakathi is a 21 year old young lady born
                            and bred in Soweto. 
                        </p>

                        <p>
                            She was the youngest Miss South Africa
                            finalist 2019. Her journey started when she was 12 years old
                            when her mom entered her into pageants. Her first pageant
                            was the Little Miss Dobsonville 2011 one which she won. That
                            is where she was introduced to giving back to her community
                            and she never looked back since. 
                        </p>

                        <p>
                            She is currently a Business
                            Information Technology student at the University of
                            Johannesburg and is the Founder and CEO of ZA Power
                            House and Soweto Diamonds
                            Model Academy and is the co-founder of Soweto Royalty
                            Foundation. Zanele is also a award winning philanthropist.
                        </p>
                    </div>
                    <div className="right-content">
                    </div>
                </div>
            </div>
        </AboutFounder>
    </Fragment>
)

export default AboutSections;